var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24.0001C18.6274 24.0001 24 18.6275 24 12.0001C24 5.37264 18.6274 6.10352e-05 12 6.10352e-05C5.37258 6.10352e-05 0 5.37264 0 12.0001C0 18.6275 5.37258 24.0001 12 24.0001Z",
    fill: "#A3DEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0146 19.9729C16.417 19.9729 19.9859 16.404 19.9859 12.0016C19.9859 7.59919 16.417 4.03033 12.0146 4.03033C7.61219 4.03033 4.04333 7.59919 4.04333 12.0016C4.04333 16.404 7.61219 19.9729 12.0146 19.9729Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4014 12.9793H12.006C11.4632 12.9793 11.0233 12.5393 11.0233 11.9966V8.4084C11.0233 7.8657 11.4632 7.42572 12.006 7.42572C12.5489 7.42572 12.9887 7.8657 12.9887 8.4084V11.0139H14.4014C14.9442 11.0139 15.3841 11.4539 15.3841 11.9966C15.3841 12.5393 14.9442 12.9793 14.4014 12.9793Z",
    fill: "#4E5660"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.d79745edc728968811034915ae165632.svg";
export { ForwardRef as ReactComponent };